<template>
  <div class="seat">
    <h4 class="title">{{ $t("seat_employee.label_seat_employee") }}</h4>
    <div>
      <b-card no-body>
        <b-tabs pills card>
          <b-tab title="Sơ đồ tầng 11" @click="() => handleFloor(11)"
            ><LayoutSeat
              :listSeatEmployee="listSeatEmployee"
              :floors="11"
              :getAllEmployee="getAllEmployee"
              v-on:handleFloor="handleFloor"
          /></b-tab>
          <b-tab title="Sơ đồ tầng 13" @click="() => handleFloor(13)"
            ><LayoutSeat
              :listSeatEmployee="listSeatEmployee"
              :floors="13"
              :getAllEmployee="getAllEmployee"
              v-on:handleFloor="handleFloor"
          /></b-tab>
          <b-tab title="Sơ đồ tầng 14" @click="() => handleFloor(14)"
            ><LayoutSeat
              :listSeatEmployee="listSeatEmployee"
              :floors="14"
              :getAllEmployee="getAllEmployee"
              v-on:handleFloor="handleFloor"
          /></b-tab>
          <b-tab title="Sơ đồ tầng 15" @click="() => handleFloor(15)"
            ><LayoutSeat
              :listSeatEmployee="listSeatEmployee"
              :floors="15"
              :getAllEmployee="getAllEmployee"
              v-on:handleFloor="handleFloor"
          /></b-tab>
          <b-tab title="Sơ đồ tầng 17" @click="() => handleFloor(17)"
            ><LayoutSeat
              :listSeatEmployee="listSeatEmployee"
              :floors="17"
              :getAllEmployee="getAllEmployee"
              v-on:handleFloor="handleFloor"
          /></b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import LayoutSeat from "@/components/SeatEmployee/LayoutSeat.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_list_seat"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    LayoutSeat,
  },
  data: function () {
    return {
      index: null,
      floor: "",
      width: 0,
      height: 0,
      employee: "",
      item: {},
    };
  },
  computed: {
    ...mapGetters({
      listSeatEmployee: "seat-employee/listSeatEmployee",
    }),
  },

  async created() {
    await this.getListsSeat();
    await this.getEmployee();
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    handleFloor: function (floor) {
      this.floor = floor;
      this.$store.dispatch("seat-employee/listSeatEmployee", floor);
    },
    getListsSeat() {
      this.$store.dispatch("seat-employee/listSeatEmployee", 11);
    },
    getEmployee() {
      this.$store.dispatch("seat-employee/getAllEmployee");
    }
  },
};
</script>
<style lang="scss" scoped>
.seat {
  border: 1px solid gray;
  padding: 10px;
  margin: 0 10px 30px 10px;
  box-shadow: 0px 4px 8px 0;
}
.title {
  text-align: center;
  padding-bottom: 15px;
}

.list-employee {
  border: 1px solid gray;
  margin: 20px 0;
}
.label-list {
  padding: 10px 0 0 20px;
}
.check-box {
  display: flex;
  text-align: center;
}
.employee-table {
  margin: 15px 5px;
  .cl-pointer {
    cursor: pointer;
    .icon-sort {
      margin-left: 5px;
      .c-icon {
        width: 12px;
      }
      .sort-rotate {
        transform: rotate(180deg);
      }
    }
  }
}
th,
td {
  vertical-align: middle !important;
}
@media only screen and (max-device-width: 767px) {
  .employee-table {
    margin: 0 20px;
  }
  .table-mobile {
    width: 1500px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .employee-table {
    margin: 1rem;
  }
  .table-tablet {
    width: 1500px;
    overflow-x: scroll;
  }
}
</style>